import Alert from './alert-controller'

export default Alert
